import type { FaireProductEntity } from "../../entity_types/product";

export const p_s7tkgxwstz: FaireProductEntity = {
  token: "p_s7tkgxwstz",
  type: "product",
  name: "Fanta Pineapple 2/12pk/12oz",
  brandToken: "b_ktcqb4hfg7",
  brandName: "L&F Universal Goods",
  imageUrl:
    "https://cdn.faire.com/fastly/04e1c87d20d7e89e36e85f86a73ac95587c2abc7c16bbed958984194e07e33b2.jpeg",
  galleryImageUrls: [],
  priceDollars: 36.03,
  description:
    "Pineapple Fanta with tropical flavor, perfect for customers seeking exotic fruit-flavored carbonated beverages.",
  tags: [],
  msrpDollars: 70.67,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:43.217Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
